import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import APP_CONFIG from "../../app/app.config";

/*
  Generated class for the CommonProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class CommonProvider {
  constructor(public http: HttpClient) {
    console.log("Hello CommonProvider Provider");
  }

  /**
   * Generate UUID for system
   * @returns {any}
   */
  generateGuid() {
    let result, i, j;
    result = "";
    for (j = 0; j < 32; j++) {
      if (j == 8 || j == 12 || j == 16 || j == 20) result = result + "-";
      i = Math.floor(Math.random() * 16)
        .toString(16)
        .toUpperCase();
      result = result + i;
    }
    return result;
  }

  /**
   * Upload hình ảnh lên server
   * @param img
   * @param callback
   */
  uploadImage(img: any, callback) {
    let formData: FormData = new FormData();
    formData.append("image", img, img.name);

    let xhr = new XMLHttpRequest();
    xhr.upload.addEventListener("progress", (ev: ProgressEvent) => {
      //You can handle progress events here if you want to track upload progress (I used an observable<number> to fire back updates to whomever called this upload)
    });

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        let data = JSON.parse(xhr.responseText);
        callback(data);
      }
    };

    xhr.open("POST", `${APP_CONFIG.baseURL}/upload/image`, true);
    xhr.send(formData);
  }

  getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
  }

  /**
   *
   */
  fetchLearnEnglish() {
    return this.http.get(`${APP_CONFIG.baseURL}/common/learn_english`);
  }
}



// WEBPACK FOOTER //
// ./src/providers/common/common.ts